/** Utilitarios de prazo compartilhados entre a lista e o viewer. */

const UM_DIA_MS = 24 * 60 * 60 * 1000;

export type PrazoStatus = 'normal' | 'urgente' | 'atrasado' | 'sem';

const fmtCurto = new Intl.DateTimeFormat('pt-BR', {
  day: '2-digit', month: '2-digit', year: 'numeric',
});
const fmtLongo = new Intl.DateTimeFormat('pt-BR', {
  weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
});

/** Formata a data do prazo (curta dd/mm/aaaa ou longa com hora). */
export function formatPrazo(iso: string, longo = false): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return (longo ? fmtLongo : fmtCurto).format(d);
}

/** Classifica o prazo: atrasado / urgente (<24h) / normal. */
export function prazoStatus(iso: string): PrazoStatus {
  if (!iso) return 'sem';
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return 'sem';
  const restante = t - Date.now();
  if (restante <= 0) return 'atrasado';
  if (restante <= UM_DIA_MS) return 'urgente';
  return 'normal';
}
